import ProducerActivityList from '@/producers/activities/List'

export default {
    // icon: LocationCityIcon,
    list: ProducerActivityList,
    // edit: CommuneEdit,
    // create: CommuneCreate
}
